import {Helper} from "@nolimitcity/promo-panel/bin/utils/Helper";
import {ASBonusPickOptions, ASMainGamePickOptions, WINTYPE} from "@nolimitcity/promo-panel/bin/enums/ASEnums";
import {
    ActionSpinOptions,
    ActionSpinSound,
    ASWinData,
    PromoPanelGameConfiguration,
} from "@nolimitcity/promo-panel/bin/interfaces/ASInterfaces";
import {GameMode} from "@nolimitcity/slot-game/bin/core/gamemode/GameMode";
import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";
import {BookOfShadowsGameMode} from "./gameMode/BookOfShadowsGameMode";
import {BookOfShadowsGameModuleConfig} from "./BookOfShadowsGameModuleConfig";
import {BookOfShadowsSoundConfig} from "./BookOfShadowsSoundConfig";
import {SoundManager} from "./sound/SoundManager";
import {BookOfShadowsGameAssets} from "./BookOfShadowsGameAssets";
import {BookOfShadowsGameConfig} from "./BookOfShadowsGameConfig";
import {APIBetEventData} from "@nolimitcity/slot-launcher/bin/interfaces/APIBetEventData";
import {BookOfShadows} from "./BookOfShadows";



export class BookOfShadowsPromoPanelConfig implements PromoPanelGameConfiguration{

    constructor() {}

    private static prevFeature = "";
    public static injectActionSpinPlayerInteractionData(data: APIBetEventData):APIBetEventData{
        if (data.playerInteraction?.actionSpin == true){

            data.playerInteraction.baseRows = BookOfShadowsGameConfig.instance.ACTIVE_ROWS;

            if (BookOfShadowsPromoPanelConfig.prevFeature.indexOf("FREESPIN") > -1){
                if (data.playerInteraction.selectedIndex != undefined){
                    delete data.playerInteraction.selectedIndex;
                }
            }

            if (data.playerInteraction.featureName != undefined){
                BookOfShadowsPromoPanelConfig.prevFeature = data.playerInteraction.featureName;
            } else {
                BookOfShadowsPromoPanelConfig.prevFeature = "";
            }


        }
        return data;
    }


    public getActionSpinOptions():ActionSpinOptions {
        return {
            gameName : "Book Of Shadows",
            hasActionSpin : true,
            bonusGame : {
                header : () => SlotGame.api.translations.translate("SHADOW ROWS BONUS:"),
                options : [
                    {name : "3 ROWS", id : 1, image : "3rows.png"},
                    {name : "4 ROWS", id : 2, image : "4rows.png"},
                    {name : "5 ROWS", id : 3, image : "5rows.png"},
                ],
                type : ASBonusPickOptions.PICK_MODE,
                pickNeededForModes : [BookOfShadowsGameMode.FREESPIN_PICK],
                pickNeededForBuyFeatures : []
            },
            graphics : {backgroundTextureName : BookOfShadowsGameAssets.INTRO_BACKGROUND},
            getParsedData : (response:any, bet:number, prevResponse:any):ASWinData => {
                const parsedData:ASWinData = {
                    totalWin : response.accumulatedRoundWin,
                    totalSpinWinnings : this.getWin(response, bet, prevResponse),
                    wasFeatureBuy : response.wasFeatureBuy,
                    freeSpinTriggeredThisSpin : this.isFreeSpinTriggered(response),
                    isBigWin : this.isBigWin(response),
                    winType : WINTYPE.NORMAL,
                    featureName : this.getFeatureName(response, prevResponse),
                    isRoundComplete : this.isRoundComplete(response),
                    isBonusEnd : this.isBonusEnd(response),
                    isWinCapHit : response.brokeTheBank
                }
                return parsedData;
            }
        };
    }

    private isBigWin(response:any): boolean {
        const win = response.totalSpinWinnings;
        const playedBetValue =  response.playedBetValue;
        let winRatio: number = Helper.ceilToDecimals((win / playedBetValue), 2);

        if (response.wasFeatureBuy) {
            const betPrice =  BookOfShadowsGameModuleConfig.featurePrice.getBuyFeaturePriceFromData(response);
            winRatio = Helper.ceilToDecimals((win / betPrice), 2);
            return winRatio >= 1;
        }

        return winRatio >= 15;
    }

    private getWin(response:any, bet:number, prevData:any):number {

        if (response.mode == BookOfShadowsGameMode.GAMBLE && prevData?.totalSpinWinnings){
            return prevData.totalSpinWinnings;
        }
        return response.totalSpinWinnings;
    }

    private getFeatureName(response:any, prevData:any):string {
        if (response.nextMode == BookOfShadowsGameMode.FREESPIN_PICK && !response.wasFeatureBuy){
            return SlotGame.api.translations.translate("FREE SPINS");
        }

        if (response.mode == BookOfShadowsGameMode.GAMBLE && prevData?.playedRowsInFS){
            return SlotGame.api.translations.translate("FREE SPINS " + prevData.playedRowsInFS + " rows");
        }

        return SlotGame.api.translations.translate("FREE SPINS " + response.playedRowsInFS + " rows");
    }

    private isFreeSpinTriggered(response:any):boolean {
        return response.freespinTriggeredThisSpin;
    }

    private isRoundComplete(response:any):boolean {
        return ([GameMode.NORMAL, BookOfShadowsGameMode.FREESPIN, BookOfShadowsGameMode.FREESPIN_PICK].indexOf(response.nextMode) > -1);
    }

    private isBonusEnd(response:any):boolean {
        return response.mode === BookOfShadowsGameMode.FREESPIN && response.nextMode === GameMode.NORMAL;
    }


    public onActionSpinPlaySound(trigger:ActionSpinSound):void {
        if (trigger == ActionSpinSound.WIN){
            SoundManager.playSoundEffect(BookOfShadowsSoundConfig.instance.AS_WIN);
        }
        else if (trigger == ActionSpinSound.BIG_WIN) {
            SoundManager.playSoundEffect(BookOfShadowsSoundConfig.instance.AS_WIN_BIG);
        }
    }

    isLegalGambleMode(mode:string):boolean {
        return mode == GameMode.GAMBLE;
    }



}